import { MeshParser } from '@seddi/mesh';
import type { BufferGeometry, LoadingManager } from '@seddi/three';
import type { VertexDataDesc } from '../domain/bufferTypes';
import { create as createGeometry } from '../three/core/bufferGeometry';
import { load as loadFile } from '../three/loaders/binaryAssetLoader';
import { adaptGeometry } from './meshAdapter';

/**
 * Load mesh.
 * @param url = Resource URL.
 * @param manager - Loading manager.
 */
export const load = async (url: string, manager: LoadingManager): Promise<BufferGeometry> => {
  const bytes = await loadFile(url, manager);
  const data = MeshParser.Parse(bytes);
  const geometryDesc: VertexDataDesc = adaptGeometry(data.geometry);
  const geometry = createGeometry(geometryDesc);
  return geometry;
};
